/**
 * Bosch Brand Guide color tokens.
 * Reference: Bosch Design System (Bosch Blue, Gray, Green, Yellow, Red gradations).
 *
 * Usage rules from the brand guide:
 * - Bosch Blue 50 (#007BC0) is the primary brand color.
 * - Design is bright and predominantly white; color is used as accent and sparingly.
 * - Bosch Red gradations may be used ONLY for error messages.
 * - Yellow is reserved for warnings/notifications.
 * - Green is reserved for success/positive states.
 */

export const boschBlue = {
  95: '#E8F1FF',
  90: '#D1E4FF',
  85: '#B8D6FF',
  80: '#9DC9FF',
  75: '#7EBDFF',
  70: '#56B0FF',
  65: '#00A4FD',
  60: '#0096E8',
  55: '#0088D4',
  50: '#007BC0', // Iconic Bosch Blue
  45: '#006EAD',
  40: '#00629A',
  35: '#005587',
  30: '#004975',
  25: '#003E64',
  20: '#003253',
  15: '#002742',
  10: '#001D33',
  5: '#001222',
};

export const boschGray = {
  95: '#EFF1F2',
  90: '#E0E2E5',
  85: '#D0D4D8',
  80: '#C1C7CC',
  75: '#B2B9C0',
  70: '#A4ABB3',
  65: '#979EA4',
  60: '#8A9097',
  55: '#7D8389',
  50: '#71767C',
  45: '#656A6F',
  40: '#595E62',
  35: '#4E5256',
  30: '#43464A',
  25: '#383B3E',
  20: '#2E3033',
  15: '#232628',
  10: '#1A1C1D',
  5: '#101112',
};

export const boschGreen = {
  95: '#E2F5E7',
  90: '#B8EFC9',
  50: '#00884A',
  40: '#006C3A',
  30: '#00512A',
};

export const boschYellow = {
  95: '#FFEFD1',
  85: '#FFCF00',
  80: '#EEC100',
  50: '#8F7300',
};

export const boschRed = {
  95: '#FFECEC',
  85: '#FFC6C6',
  50: '#ED0007',
  40: '#BE0004',
};

export const boschWhite = '#FFFFFF';
export const boschBlack = '#000000';
